import React from "react";
import "./styles/global.css";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { logger } from "./utils";
// Initialize performance monitoring early
import { performanceMonitor } from "./utils/performanceMonitor";

// Mark app start time for performance tracking
performanceMonitor.mark('app-start');

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container, {
  onRecoverableError: (error) => {
    logger.log(error);
  },
});

// Render the app - MFE is handled via routes in AppRoutes.tsx
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// Track render completion
performanceMonitor.mark('app-rendered');
performanceMonitor.measure('app-render-time', 'app-start', 'app-rendered');

// Initialize Sentry after React has rendered
if (typeof window !== "undefined" && "requestIdleCallback" in window) {
  requestIdleCallback(
    () => {
      import("./sentry").then(({ initSentry }) => initSentry());
    },
    { timeout: 2000 }
  );
} else {
  setTimeout(() => {
    import("./sentry").then(({ initSentry }) => initSentry());
  }, 1000);
}
